import { filtersOptions, filtersState } from "../state/CommonState";
import filtericon from "../assets/images/filtericon.svg";
import { Box } from "@mui/system";
import { LabeledRadioButton } from "../v3-componets/AgLabeledRadioButton";
import { useEffect, useState } from "react";
import { CheckBoxGroup } from "./CheckBoxGroup";
import { CustomAccordion } from "./CustomAccordion";
import { useSnapshot } from "valtio";
import { enquiryStore } from "../enquiry/enquiry-data";
import { Constants } from "../util/Utils";

function SortBy() {
    const [sortedBy, setSortedBy] = useState(filtersState.sortedBy);
    useEffect(()=>{
        if(sortedBy===0){
            filtersState.sortedBy = 0
            filtersState.cheapestFastestFilter("CHEAPEST")
        }else if(sortedBy===1){
            filtersState.sortedBy = 1
            filtersState.cheapestFastestFilter("FASTEST")
        }else if(sortedBy===2){
             filtersState.sortedBy = 2
            filtersState.cheapestFastestFilter(Constants.earlyDeparture)
        }else if(sortedBy===3){
            filtersState.sortedBy = 3
            filtersState.cheapestFastestFilter(Constants.earlyArrival)
        }
    },[filtersOptions])
    return <>
        <LabeledRadioButton fontSize="14px" selected={sortedBy === 0} label="Cheapest" onClick={() => {
            setSortedBy(0);
            filtersState.sortedBy = 0
            filtersState.cheapestFastestFilter("CHEAPEST")
        }} />
        <LabeledRadioButton fontSize="14px" selected={sortedBy === 1} label="Fastest" onClick={() => {
            setSortedBy(1);
            filtersState.sortedBy = 1
            filtersState.cheapestFastestFilter("FASTEST")
        }} />
         <LabeledRadioButton fontSize="14px" selected={sortedBy === 2} label="Early Departure" onClick={() => {
            setSortedBy(2);
            filtersState.sortedBy = 2
            filtersState.cheapestFastestFilter(Constants.earlyDeparture)
        }} />
        <LabeledRadioButton fontSize="14px" selected={sortedBy === 3} label="Early Arrival" onClick={() => {
            setSortedBy(3);
            filtersState.sortedBy = 3
            filtersState.cheapestFastestFilter(Constants.earlyArrival)
        }} />
    </>
}

export function getTotalResultCount(results){
   if(!results || results.length===0) return 0
   let total = 0;
   results.forEach((result)=>{
     total += result.dummyContract?.schedules?.length || 1;
   })

   return total;
}

export function QuickQuoteFilters({showSortBy=true}) {
    useSnapshot(filtersState);
    let filterOptionsSnap = useSnapshot(filtersOptions);

    useEffect(() => {
        filtersState.filterRoutes();
    }, [filterOptionsSnap])

    if (filtersOptions.options?.length === 0) return <></>;

    return <Box sx={{ width: "210px", backgroundColor: "white", borderRadius: "7px", display: "flex", flexDirection: "column", height: "max-content", position: "sticky", top: 0 }}>
        <div className="w-full flex flex-col gap-[6px] py-3 px-[18px] rounded-t-[7px] bg-blue-dark">
            <div className="flex flex-row gap-3">
                <img src={filtericon} />
                <p className="text-white text-[18px] font-bold">Filter</p>
            </div>
            <p className="text-[#FFFFFF94]">{filtersState.filteredList.length} of {getTotalResultCount(filtersState.routes)} results</p>
        </div>
        <div className="flex flex-col py-3">
         {showSortBy && <div className="flex flex-col gap-3 px-[14px] pb-3 border-b-2 border-b-solid border-b-[#E2E2E2] ">
                <p className="text-blue-dark text-sm font-semibold">Sort By</p>
                <SortBy />
            </div>}
            {filtersOptions.options.map((filterOption) => filterOption.isAccordionView ? <div className="px-[14px]"><CheckBoxGroup options={filterOption.options} /></div> : <CustomAccordion filterOption={filterOption} />)}
        </div>
    </Box>
}